<div class="form-check form-switch p-0">
  <div class="d-inline-flex flex-row-reverse gap-1">
    <input class="form-check-input ms-0" type="checkbox" role="switch" id="switch{{id}}" (change)="change()"
      [checked]="isChecked" style="margin-top: 0px; height: 25px;width: 50px;" #switchid="casiclicklogger"
      casiClickLogger="false" />
    <label class="form-check-label ms-2 me-2" for="switch{{id}}">{{label}}</label>
  </div>
</div>
